module.exports = __webpack_public_path__ + "img/7-3-koordinacia.74da224d.jpg";